const STORAGE_KEY = "latestPages";

function loadFromLocalStorage() {
  try {
    const data = JSON.parse(localStorage.getItem(STORAGE_KEY));
    return data || {};
  } catch {
    return {};
  }
}

function saveToLocalStorage(entities) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(entities));
}

const state = () => ({
  entities: loadFromLocalStorage(),
});

const mutations = {
  SET_LAST_VISITED(state, { key, id, name, route }) {
    state.entities = {
      ...state.entities,
      [key]: { id, name, route },
    };
    saveToLocalStorage(state.entities);
  },
  CLEAR_LAST_VISITED(state, key) {
    const { [key]: _, ...rest } = state.entities;
    state.entities = rest;
    saveToLocalStorage(state.entities);
  },
  CLEAR_ALL(state) {
    state.entities = {};
    localStorage.removeItem(STORAGE_KEY);
  },
};

const actions = {
  setLastVisited({ commit }, payload) {
    commit("SET_LAST_VISITED", payload);
  },
  clearLastVisited({ commit }, key) {
    commit("CLEAR_LAST_VISITED", key);
  },
  clearAll({ commit }) {
    commit("CLEAR_ALL");
  },
};

const getters = {
  getLastVisited: (state) => (key) => {
    return state.entities[key] || null;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
